const CHARS =
  'A-Za-z\u00c0\u00c1\u00c2\u00c3\u00c4\u00c5\u00e0\u00e1\u00e2\u00e3\u00e4\u00e5\u00c6\u00e6\u00df\u00c8\u00c9\u00ca\u00cb\u00e8\u00e9\u00ea\u00eb\u00cc\u00cd\u00ce\u00cfI\u0130\u00ec\u00ed\u00ee\u00ef\u0131i\u0152\u0153\u00d2\u00d3\u00d4\u00d5\u00d6\u00d8\u00f8\u00f2\u00f3\u00f4\u00f5\u00f6\u00f8\u00d9\u00da\u00db\u00dc\u00f9\u00fa\u00fb\u00fc\u0178\u00dd\u00fd\u00ff\u00c7\u00e7\u00d1\u00f1\u00d0\u00fe\u00de\u00b5\u0160\u0161Ss\u015e\u015fG\u011eg\u011f\u0192';

const NAME_REGEX = new RegExp(`^[- '${CHARS}]{2,}$`);
const EMAIL_REGEX = new RegExp(
  '^[A-Za-z0-9](([-_.]?)[A-Za-z0-9])+@[A-Za-z0-9](([-_.]?)[A-Za-z0-9])+(\\.[A-Za-z]{2,4})$'
);
const PHONE_REGEX = new RegExp('^([0-9() -]{7,15})$');

const regexValidator =
  (regex) =>
  (value = '') =>
    regex.test(value);

export const validateName = regexValidator(NAME_REGEX);
export const validateEmail = regexValidator(EMAIL_REGEX);
export const validatePhone = regexValidator(PHONE_REGEX);
